import Vue from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import Dropdown from "primevue/dropdown";
import Textarea from "primevue/textarea";
import InputText from "primevue/inputtext";
import OverlayPanel from "primevue/overlaypanel";
import Sidebar from "primevue/sidebar";
import Listbox from "primevue/listbox";
import ToastService from "primevue/toastservice";
import Checkbox from "primevue/checkbox";
import InputSwitch from "primevue/inputswitch";
import Tooltip from "primevue/tooltip";
import Calendar from "primevue/calendar";
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Fieldset from 'primevue/fieldset';

Vue.component("Calendar", Calendar);
Vue.component("DataTable", DataTable);
Vue.component("Column", Column);
Vue.component("Dialog", Dialog);
Vue.component("Button", Button);
Vue.component("Dropdown", Dropdown);
Vue.component("Textarea", Textarea);
Vue.component("InputText", InputText);
Vue.component("OverlayPanel", OverlayPanel);
Vue.component("Sidebar", Sidebar);
Vue.component("Listbox", Listbox);
Vue.component("Accordion", Accordion);
Vue.component("AccordionTab", AccordionTab);
Vue.component("Fieldset", Fieldset);
Vue.use(ToastService);
Vue.component("Checkbox", Checkbox);
Vue.component("InputSwitch", InputSwitch);
Vue.directive("tooltip", Tooltip);


export default Vue;
